export default __webpack_public_path__ + "static/media/Icon_Class_WindRuner.e335638f.png";